<script>
import {
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  LinkedinIcon,
} from "vue-feather-icons";
export default {
  components: {
    FacebookIcon,
    TwitterIcon,
    InstagramIcon,
    LinkedinIcon,
  },
  computed: {
    lang() {
      return localStorage.getItem("locale") || "uz_latn";
    },
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <section
      class="footer"
      style="background-image: url(assets/images/footer-bg.png)"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="mb-5">
              <img
                src="@/assets/images/1-logo.white.png"
                width="250px"
                alt
                class
                height="80"
              />
              <!-- <img v-if="lang != 'ru'" src="@/assets/images/design/logouzbdark.png" alt class height="38" /> -->
              <!-- <p class="text-white-50 my-4 font-size-15">
                Программный комплекс «Опека, попечительства и усыновления
                (удочерения) детей»
              </p> -->
              <!-- <ul class="list-inline footer-social-icon-content">
                <li class="list-inline-item mr-4">
                  <a href="javascript: void(0);" class="footer-social-icon">
                    <facebook-icon></facebook-icon>
                  </a>
                </li>
                <li class="list-inline-item mr-4">
                  <a href="javascript: void(0);" class="footer-social-icon">
                    <twitter-icon></twitter-icon>
                  </a>
                </li>
                <li class="list-inline-item mr-4">
                  <a href="javascript: void(0);" class="footer-social-icon">
                    <instagram-icon></instagram-icon>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="javascript: void(0);" class="footer-social-icon">
                    <linkedin-icon></linkedin-icon>
                  </a>
                </li>
              </ul> -->
            </div>
          </div>
          <div class="col-lg-7 offset-lg-1">
            <div class="row">
              <!-- <div class="col-md-4">
                <h6 class="text-white text-uppercase mb-4">About Us</h6>
                <ul class="list-unstyled footer-sub-menu">
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Works</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Strategy</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Releases</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Press</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Mission</a>
                  </li>
                </ul>
              </div> -->
              <div class="col-md-4">
                <!-- <h6 class="text-white text-uppercase mb-3">Customers</h6>
                <ul class="list-unstyled footer-sub-menu">
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Tranding</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Popular</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Customers</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">Features</a>
                  </li>
                </ul> -->
              </div>
              <div class="col-md-8">
                <h6 class="text-white text-uppercase mb-3">Контакты</h6>
                <ul class="list-unstyled footer-sub-menu">
                  <li>
                    <a href="javascript: void(0);" class="footer-link"
                    >+998 71-239-24-12 (09:00-18:00)</a
                    >
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link"
                    >+998 (95) 341-50-40 (09:00-18:00)</a
                    >
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link"
                      >+998 (95) 340-50-40 (09:00-18:00)</a
                    >
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link"
                      >+998 (95) 341-40-60 (09:00-18:00)</a
                    >
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">{{
                      $t("addressSport")
                    }}</a>
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link">
                      info@minsport.uz</a
                    >
                  </li>
                  <li>
                    <a href="javascript: void(0);" class="footer-link"
                      >sport@exat.uz</a
                    >
                  </li>
                  <!-- <li>
                    <a href="javascript: void(0);" class="footer-link">Guide</a>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <div class="footer-alt py-3">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center">
              <p class="text-white-50 font-size-15 mb-0">
                {{ new Date().getFullYear() }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Footer End -->
  </div>
</template>
